// extracted by mini-css-extract-plugin
export default {"layout":"LogementType_layout__wdO3Q","ophelie":"LogementType_ophelie__ChTNR"};